import type { RoadmapDetailCoursesItemInstructorBasicInfo } from './roadmapDetailCoursesItemInstructorBasicInfo';
import type { RoadmapDetailCoursesItemInstructorSocial } from './roadmapDetailCoursesItemInstructorSocial';

/**
 * 강사 정보
 */
export type RoadmapDetailCoursesItemInstructor = {
  /** 사용자 기본 정보 */
  basicInfo: RoadmapDetailCoursesItemInstructorBasicInfo;
  /** 소셜 관계 정보 */
  social?: RoadmapDetailCoursesItemInstructorSocial;
};
